<template>
  <b-row>
    <b-col
      cols="12"
      md="8"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <b-form-group
                label-for="v-image"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.banner.title"
                    :description="labelForm.banner.description"
                    required
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Gambar"
                  rules="required"
                >
                  <form-image
                    v-model="form.image"
                    label="Pilih Gambar"
                    :state="errors.length > 0 ? false : null"
                    width-full
                    aspect-ratio="2/1"
                    @finish="setImageFile"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Nama -->
              <b-form-group
                label-for="v-name"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.name.title"
                    :description="labelForm.name.description"
                    required
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Nama"
                  rules="required"
                >
                  <b-form-input
                    id="v-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Lokasi -->
              <b-form-group
                label-for="v-location"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.location.title"
                    :description="labelForm.location.description"
                    required
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Lokasi"
                  rules="required"
                >
                  <v-select
                    v-model="form.location"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="locationList"
                    :reduce="option => option.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Type -->
              <b-form-group
                label-for="v-type"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.type.title"
                    :description="labelForm.type.description"
                    required
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Tipe"
                  rules="required"
                >
                  <div class="demo-inline-spacing">
                    <b-form-radio
                      v-model="form.type"
                      class="mt-0"
                      name="type"
                      value="direct"
                    >
                      Direct
                    </b-form-radio>
                    <b-form-radio
                      v-model="form.type"
                      class="mt-0"
                      name="type"
                      value="page"
                    >
                      Page
                    </b-form-radio>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Link -->
              <b-form-group
                v-if="form.type === 'direct'"
                label-for="v-link"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.link.title"
                    :description="labelForm.link.description"
                    required
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Link"
                  rules="required"
                >
                  <b-form-input
                    id="v-link"
                    v-model="form.link"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Deskripsi -->
              <b-form-group
                v-if="form.type === 'page'"
                label-for="v-description"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.description.title"
                    :description="labelForm.description.description"
                    required
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Deskripsi"
                  rules="required"
                >
                  <quill-editor
                    id="v-description"
                    v-model="form.description"
                    class="medium-height"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Aktif -->
              <b-form-group
                label-for="v-type"
                label-cols-md="4"
                label-class="pt-0"
              >
                <template #label>
                  <FormLabel
                    :title="labelForm.active.title"
                    :description="labelForm.active.description"
                  />
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Aktif"
                >
                  <b-form-checkbox
                    v-model="form.active"
                    :checked="true"
                    class="mt-0"
                    name="active"
                    switch
                    inline
                  >
                    Aktif
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormRadio,
  BFormCheckbox,
  BButton,
  BSpinner,
  BOverlay,
} from 'bootstrap-vue'

import FormImage from '@/layouts/components/custom/FormImage.vue'
import FormLabel from '@/layouts/components/custom/FormLabel.vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BFormCheckbox,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    FormImage,
    FormLabel,
    quillEditor,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        image: '',
        imageFile: '',
        name: '',
        type: '',
        description: '',
        link: '',
        active: '',
        location: '',
      },
      required,
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState('banner', ['banner', 'labelForm', 'locationList']),
    bannerId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getBanner({ id: this.bannerId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('banner', ['getBanner', 'createBanner', 'updateBanner']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    setImageFile(file) {
      if (file) {
        this.form.imageFile = file
      }
    },
    async handleSubmit() {
      this.isSubmitting = true

      if (!this.isEdit) {
        await this.createBanner(this.form)
          .then(() => {
            this.$router.push('/banners')
          })
          .catch(() => {
            this.isSubmitting = false
          })
      } else {
        await this.updateBanner({ bannerId: this.bannerId, data: this.form })
          .then(() => {
            this.$router.push('/banners')
          })
          .catch(() => {
            this.isSubmitting = false
          })
      }
    },
    // Edit State Only
    fillData() {
      this.form.image = this.linkStaging(this.banner.data.image, 100, 100)
      this.form.name = this.banner.data.name
      this.form.type = this.banner.data.type
      this.form.description = this.banner.data.description
      this.form.link = this.banner.data.link
      this.form.active = this.banner.data.active
      this.form.location = this.banner.data.location
    },
  },
}
</script>

<style lang="scss">
.image-preview {
    width: 102px;
    height: 102px;
    background-color: white;
    border: 1px solid red;
    position: relative;
    img {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
